import type { VivaError } from '@viva/core';
import { t, useLanguage } from '../i18n';

/** User-facing error: a plain sentence only (technical details are not shown to viewers). */
export function ErrorMessage({ error, onDismiss }: { error: VivaError; onDismiss?: () => void }) {
  useLanguage();
  const message =
    error.code === 'invalid-input'
      ? error.message
      : error.code === 'http' && error.status !== undefined && error.status >= 400 && error.status !== 404 && !(error.status >= 500 && error.status < 600)
        ? // Panels answer refusals with arbitrary codes (403, 456, even 884); 5xx stay "server error".
          t('errors.refused')
        : error.code === 'http' && error.status === 404
          ? t('errors.notFound')
          : error.code === 'http' && error.status !== undefined && error.status >= 500
            ? // Includes Cloudflare 52x codes that IPTV panels behind Cloudflare return.
              t('errors.serverProblem')
            : t(`errors.${error.code}`);
  return (
    <div className="error" role="alert">
      <div>
        <strong>{message}</strong>
      </div>
      {onDismiss ? (
        <button type="button" className="button ghost" onClick={onDismiss}>
          {t('common.dismiss')}
        </button>
      ) : null}
    </div>
  );
}
